import React, { useEffect, useState, useCallback } from "react";
import RoleForm from "./RoleForm";
import ObjectList from "../../../Common/ObjectList";
import ObjectListMobile from "../../../Common/ObjectListMobile";
import commonConstants from "../../../Common/CommonConstants";
import http from "../../../Common/RestAPIHandler";
import {userRoleManagement} from "../../../Common/Languages";

const redirect = (props, object, property) => {
  if (!object.rp_disabled) props.history.push("/settings/user/roles/" + object.id);
  else alert("Role status is disabled.");
};

const lang = localStorage.getItem("languages");

const tableColumns = [
  {
    id: "role_name",
    label: userRoleManagement.ROLENAME[lang],
    minWidth: 150,
    sortable: true,
    style: commonConstants.cellCursor,
    colored: true,
    onClick: redirect,
  },
  {
    id: "description",
    label: userRoleManagement.ROLEDESCRIPTION[lang],
    minWidth: 220,
    sortable: true,
  },
  { id: "created_by_name", label: userRoleManagement.CREATEDBY[lang], minWidth: 150, sortable: true },
  { id: "status", label: userRoleManagement.STATUS[lang], minWidth: 100, sortable: true },
];

const RoleList = (props) => {
  const [data, setData] = useState([]);
  const [loadData, setLoadData] = useState(false);
  const url = `roles`;
  const actions = {
    delete: true,
    importCSV: false,
    exportCSV: false,
    exportPDF: false,
  };

  const fetchData = useCallback(() => {
    setLoadData(true);
    http.Get(
      url,
      (data) => {
        data.forEach(
          (item) => {
            item.rp_disabled = !item.status;
            item.status = item.status ? "Active" : "Disabled";
          }
        );
        setData(data);
        setLoadData(false);
      },
      () => {
        setLoadData(false);
      }
    );
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <>
    {!props.mobile && 
    <ObjectList
      {...props}
      moduleName={userRoleManagement.SecurityControl[lang]}
      url={url}
      actions={actions}
      permissions={{
        create: ["Manage Users"],
        edit: ["Manage Users"],
        delete: ["Manage Users"],
      }}
      tableColumns={tableColumns}
      data={data}
      fetchData={fetchData}
      objectForm={RoleForm}
      orderBy={"role_name"}
      searchFields={["role_name"]} 
      pageHeader={(props.user.company_name || "") + " | Users and Control"}
      loadData={loadData}
    />
    }
    {props.mobile && 
    <ObjectListMobile
      {...props}
      moduleName={"Security Control"}
      url={url}
      actions={actions}
      permissions={{
        create: ["Manage Users"],
        edit: ["Manage Users"],
        delete: ["Manage Users"],
      }}
      tableColumns={tableColumns}
      data={data}
      fetchData={fetchData}
      objectForm={RoleForm}
      orderBy={"role_name"}
      searchFields={["role_name"]}
      pageHeader={(props.user.company_name || "") + " | Users and Control"}
      loadData={loadData}
    />
    }
    </>
  );
};

export default RoleList;
